<template>
    <SectionBasicLayout>
        <template #content>
            <div class="push-center">
                <div class="dashboard-header">
                    <i class="far fa-envelope"></i>
                    <p v-if="folders_selection_collection.count > 0">
                        <strong>
                            {{getSelectedFolderName()}}
                        </strong>
                    </p>
                    <p v-else>
                        <strong>
                            {{Language.say('folders.list.title')}}
                        </strong>
                    </p>
                </div>

                <div class="dashboard-actions" v-if="folders_selection_collection.count > 0">
                    <FoldersContextActions
                      :show_folder_name="false"
                      :webmail_view="webmail_view"
                      :context_folder='getSelectedFolder()'
                      :state_initiator="initiator"
                      block="dashboard_actions"
                    />
                </div>

                <div class="dashboard-actions" v-else>
                    <ActionButton
                        @click="onFoldersCreate()"
                        text='folders.actions.add_folder'
                        icon='fas fa-plus-circle'
                        class='clear'
                    />
                    <ActionButton
                        @click="onFoldersReload()"
                        text='folders.actions.refresh'
                        :icon="folders_controller.content_state.loading_background === true ? 'fas fa-redo-alt fa-spin' : 'fas fa-redo-alt'"
                        class='clear'
                    />
                </div>
            </div>
        </template>
    </SectionBasicLayout>
</template>
<script setup>
  import {defineProps}         from 'vue';
  import FoldersContextActions from '@/vue/Views/Folders/Partials/FoldersContextActions.vue'
  import SectionBasicLayout    from '@/vue/Layouts/Sections/SectionBasicLayout.vue';
  import ActionButton          from '@/vue/Elements/Buttons/ActionButton.vue';
  import FoldersController     from '@/js/Mailboxes/FoldersController';
  import Language              from '@/js/Shared/Language/Language.js';

  const props = defineProps({
    folders_selection_collection : {
      required : true,
    },

    webmail_view : {
      required: true,
    }
  })

  const folders_controller = FoldersController
  const initiator          = 'folders_list';

  const onFoldersReload = () => {
    folders_controller.fetchBackground();
  }

  const onFoldersCreate = () => {
    folders_controller.collection_state.setInitiator(initiator)
    props.webmail_view.openFoldersCreate()
    folders_controller.fetchBackground();
  }

  const getSelectedFolderName = () => {
    return props.folders_selection_collection.getFirst().name;
  }

  const getSelectedFolder = () => {
    return props.folders_selection_collection.getFirst();
  }
</script>
